import { Box } from "@mui/system";
import React, { useContext, useEffect, useState } from "react";
import classes from "./CreateStudentForm.module.css";
import StudentCard from "./StudentCard";
import {
  fetchArchivedStudents,
  fetchDivisions,
  getClasses,
} from "../../utilities/const/functions";
import { AuthContext } from "../../utilities/context/AuthContext";
import { Button, FormControl, Grid, TablePagination } from "@mui/material";
import Select from "react-select";
import {
  flexBetweenWithItemsCenter,
  itemsCenter,
} from "../../utilities/commonStyles/commonStyles";
import { useNavigate } from "react-router-dom";
import { reactSelectTheme } from "../../utilities/const/const";

export default function ArchivedStudentList() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState([]);
  const [page, setPage] = useState(0);
  const [divisions, setDivisions] = useState([]);
  const [searchQuery, setSearchQuery] = useState({
    division: "",
    classCode: "",
  });
  const [classCodes, setClassCodes] = useState([]);
  const { setLoading } = useContext(AuthContext);
  const fetchInitData = async () => {
    setDivisions([]);
    try {
      setLoading(true);

      const divisionRes = await fetchDivisions();
      if (!divisionRes.error) {
        setDivisions(divisionRes.data);
      }

      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };
  const fetchClassCodeData = async (id) => {
    if (!id) {
      return;
    }
    setClassCodes([]);
    try {
      setLoading(true);
      const classCodeRes = await getClasses(id);
      if (!classCodeRes.error) {
        setClassCodes(classCodeRes.data);
      }

      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await fetchArchivedStudents();
      //   console.log({ res });
      if (!res.error) {
        setUsers(res.data);
        setSearch(res.data);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const handleSearch = (value) => {
    try {
      let newData = users;
      // console.log({ value });
      newData = newData.filter((e) => {
        return (
          e.id.toLowerCase().includes(value.toLowerCase()) ||
          e.name.toLowerCase().includes(value.toLowerCase())
        );
      });
      setSearch(newData);
    } catch (e) {}
  };
  const handleFilter = () => {
    try {
      if (!searchQuery.classCode) {
        window.alert("Please select a class code");
        return;
      }
      let newData = users;
      newData = newData.filter((e) => {
        return e?.classCode?.includes(searchQuery.classCode);
      });
      setSearch(newData);
    } catch (e) {
      console.log(e);
    }
  };
  const handleClearFilter = () => {
    try {
      let newData = users;
      setSearch(newData);
      setSearchQuery({
        division: "",
        classCode: "",
      });
    } catch (e) {
      console.log(e);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    fetchUsers();
    fetchInitData();
    return () => {
      setUsers([]);
    };
  }, []);

  return (
    <Box>
      <Box sx={{ px: 5 }}>
        <Box sx={{ ...itemsCenter, gap: "30px" }}>
          <Box
            sx={{ ...flexBetweenWithItemsCenter, gap: "20px", width: "70%" }}
          >
            <input
              type="text"
              name="name"
              placeholder="Search..."
              style={{
                height: "64px",
                width: "360px",
                boxShadow: "0px 11px 18px rgba(0, 0, 0, 0.08)",
                borderRadius: "61px",
              }}
              onChange={(e) => {
                handleSearch(e.target.value);
              }}
              className={classes.formInput}
            />
            <FormControl sx={{ m: 1, width: 200 }}>
              <Select
                placeholder="Select Division"
                name="division"
                value={
                  divisions.find((obj) => obj.id === searchQuery.division) ??
                  null
                }
                theme={reactSelectTheme}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    height: "42px",
                  }),
                }}
                options={divisions
                  .slice()
                  .sort((a, b) => a.name.localeCompare(b.name))}
                getOptionLabel={(options) => options.name}
                getOptionValue={(option) => option.id}
                onChange={(e) => {
                  setSearchQuery({
                    ...searchQuery,
                    division: e.id,
                  });
                  setSearch(users);
                  fetchClassCodeData(e.id);
                }}
              />
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: "250px" }}>
              <Select
                placeholder="Select ClassCode"
                value={classCodes.find(
                  (obj) => obj.id === searchQuery.classCode
                )}
                theme={reactSelectTheme}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    height: "42px",
                  }),
                }}
                options={classCodes
                  .slice()
                  .sort((a, b) => a.classCode.localeCompare(b.classCode))}
                getOptionLabel={(options) => options.classCode}
                getOptionValue={(option) => option.id}
                onChange={(e) => {
                  setSearchQuery({
                    ...searchQuery,
                    classCode: e.id,
                  });
                }}
              />{" "}
            </FormControl>
          </Box>
          <Box sx={{ gap: "10px", width: "30%" }}>
            <Button
              onClick={handleFilter}
              sx={{
                background: "#FFFFFF",
                boxShadow: "2px 2px 8px rgba(0, 0, 0, 0.25)",
                borderRadius: "6px",
                padding: "5px 10px",
                color: (theme) => theme.palette.secondary.main,
                "&:hover": {
                  background: "#FFFFFF",
                },
              }}
            >
              Filter
            </Button>
            <Button
              onClick={handleClearFilter}
              sx={{
                background: "transparent",
                borderRadius: "6px",
                padding: "5px 10px",
                color: (theme) => theme.palette.secondary.main,
                "&:hover": {
                  background: "transparent",
                },
              }}
            >
              Clear Filter
            </Button>
            <Button
              onClick={() => {
                navigate("archived");
              }}
              sx={{
                background: "transparent",
                borderRadius: "6px",
                padding: "5px 10px",
                color: (theme) => theme.palette.secondary.main,
                "&:hover": {
                  background: "transparent",
                },
              }}
            >
              Archived Users
            </Button>
          </Box>
        </Box>
        <Grid
          container
          rowSpacing={4}
          // minHeight="70vh"
          columnSpacing={{ xs: 1, sm: 2, md: 4 }}
          sx={{ mt: 1 }}
        >
          {search
            ?.sort((a, b) => {
              return a.name > b.name ? 1 : -1;
            })
            .slice(page * 20, page * 20 + 20)
            .map((e, index) => (
              <StudentCard item={e} key={index} />
            ))}
        </Grid>
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={search.length}
          rowsPerPage={20}
          page={page}
          onPageChange={handleChangePage}
          // onRowsPerPageChange={handleChangeRowsPerPage}
        >
          Show Entries
        </TablePagination>
      </Box>
    </Box>
  );
}
